<template>
  <PageBlocks
    :content="page?.blocks"
    :error="error"
    :debug="false"
  />
</template>

<script setup>
const route = useRoute();
const { error, page } = await useFetchByPath(route.path);
</script>